import {BookingsActions, BookingsMutation} from "./types";
import axios from "axios";

export default {
    [BookingsActions.LOAD_INQUIRY]({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit(BookingsMutation.REQUEST);

            let {sortBy, sortDesc, page, itemsPerPage} = payload.options;

            axios.post('/inquiry', {
                sortBy,
                sortDesc,
                page,
                itemsPerPage,
                filter: payload.filter,
            })
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(BookingsMutation.SUCCESS_INQUIRY, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(BookingsMutation.ERROR, err.response?.data || err);
                    reject(err);
                });
        });
    },
    [BookingsActions.LOAD_BOOKINGS]({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit(BookingsMutation.REQUEST);

            let {sortBy, sortDesc, page, itemsPerPage} = payload.options;

            axios.post('/booking', {
                sortBy,
                sortDesc,
                page,
                itemsPerPage,
                filter: payload.filter,
            })
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(BookingsMutation.SUCCESS_BOOKINGS, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(BookingsMutation.ERROR, err.response?.data || err);
                    reject(err);
                });
        });
    },
    [BookingsActions.LOAD_DETAIL]({commit}, id) {
        return new Promise((resolve, reject) => {
            commit(BookingsMutation.REQUEST);

            axios.get(`/inquiry/${id}`)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(BookingsMutation.SUCCESS_DETAIL, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(BookingsMutation.ERROR, err.response?.data || err);
                    reject(err);
                });
        });
    },
    [BookingsActions.CONFIRM]({commit}, {bookingNumber}) {
        return new Promise((resolve, reject) => {
            commit(BookingsMutation.REQUEST_BOOKING);

            axios.post(`/inquiry/${bookingNumber}/confirm`)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(BookingsMutation.SUCCESS_BOOKING);
                    resolve(data);
                })
                .catch(err => {
                    commit(BookingsMutation.ERROR, err.response.data || err);
                    reject(err);
                });
        });
    },
    [BookingsActions.DECLINE]({commit}, {bookingNumber}) {
        return new Promise((resolve, reject) => {
            commit(BookingsMutation.REQUEST_BOOKING);

            axios.post(`/inquiry/${bookingNumber}/decline`)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(BookingsMutation.SUCCESS_BOOKING);
                    resolve(data);
                })
                .catch(err => {
                    commit(BookingsMutation.ERROR, err.response.data || err);
                    reject(err);
                });
        });
    },
    [BookingsActions.OFFER]({commit}, {offer, bookingNumber}) {
        return new Promise((resolve, reject) => {
            commit(BookingsMutation.REQUEST_BOOKING);

            axios.post(`/inquiry/${bookingNumber}/offer`, offer)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(BookingsMutation.SUCCESS_BOOKING);
                    resolve(data);
                })
                .catch(err => {
                    commit(BookingsMutation.ERROR, err.response.data || err);
                    reject(err);
                });
        });
    },
}
